import { useCallback } from 'react';
import { useApiGestao } from 'servicos/api-gestao/base';
import { normalizarDocumento } from 'utils/cpfcnpj-format';

export function useCadastrarContrato() {
  const { invocarApi, ...outrasPropriedades } = useApiGestao({
    config: {
      url: 'contrato',
      method: 'POST',
    },
  });

  const cadastrarContrato = useCallback(
    async (dados: any) => {
      const dadosNormalizados = {
        ...dados,
        empresa: {
          ...dados.empresa,
          Cep: dados.empresa.Cep.replace(/\D+/g, ''),
          Doc: normalizarDocumento(dados.empresa.Doc),
          Email: dados.usuario.email,
        },
        descricao: `Cadastro ${dados.empresa.Doc}`,
      };

      const ret = await invocarApi({
        data: dadosNormalizados,
        enviarTokenIntegracao: true,
        enviarTokenUsuario: false,
        forcarTokenIntegracao: false,
      });

      let retError = {};
      //ERRO NO TOKEN
      if (ret.statusCode === 401) {
        retError = await invocarApi({
          data: dadosNormalizados,
          enviarTokenIntegracao: true,
          enviarTokenUsuario: false,
          forcarTokenIntegracao: true,
        });
      }
      return { ...ret, ...retError };
    },
    [invocarApi],
  );

  return {
    ...outrasPropriedades,
    cadastrarContrato,
  };
}
